import { render, staticRenderFns } from "./oauth-error-page.vue?vue&type=template&id=3ed2e154&lang=pug&"
import script from "./oauth-error-page.vue?vue&type=script&lang=js&"
export * from "./oauth-error-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports